import { render, staticRenderFns } from "./SplitRuleManage.vue?vue&type=template&id=31d2c334&scoped=true"
import script from "./SplitRuleManage.vue?vue&type=script&lang=js"
export * from "./SplitRuleManage.vue?vue&type=script&lang=js"
import style0 from "./SplitRuleManage.vue?vue&type=style&index=0&id=31d2c334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d2c334",
  null
  
)

export default component.exports